export default {
	monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	abvMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	customFormatter(date, format) {
		let fDate = new Date(date);

		if (format === 'dash') {
			return `${(fDate.getMonth() + 1)}-${fDate.getDate()}-${fDate.getFullYear()}`;
		}
		else if (format === 'slash') {
			return `${(fDate.getMonth() + 1)}/${fDate.getDate()}/${fDate.getFullYear()}`;
		}
		else {
			return `${(fDate.getMonth() + 1)}/${fDate.getDate()}/${fDate.getFullYear()}`;
		}
	},
	formatDate(date) {
		let fDate = new Date(date);

		return `${this.monthNames[fDate.getMonth()]} ${fDate.getDate()}, ${fDate.getFullYear()}`;
	},
	formatDateAbv(date) {
		let fDate = new Date(date);
		//let month = fDate.getMonth() + 1;
		//if (month === 5) {
			return `${this.abvMonthNames[fDate.getMonth()]} ${fDate.getDate()}, ${fDate.getFullYear()}`;
		//} else {
			//return `${this.abvMonthNames[fDate.getMonth()]}. ${fDate.getDate()}, ${fDate.getFullYear()}`;
		//}
	},
	formatDay(date) {
		let fDate = new Date(date);

		return `${fDate.getDate()}`;
	},
	formatMonth(date) {
		let fDate = new Date(date);

		return `${this.abvMonthNames[fDate.getMonth()]}`;
	},
	formatDateRange(start, end) {
		let startDate = new Date(start);
		let endDate = new Date(end);
		if (startDate === '0001-01-01T00:00:00' || startDate.getFullYear() < 1990) {
			return '';
		}
		if (end === '0001-01-01T00:00:00' || endDate.getFullYear() <= 1 || startDate === endDate) {
			return `${this.monthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()}`;
		}
		else if (startDate.getFullYear() === endDate.getFullYear()) {
			if (startDate.getMonth() === endDate.getMonth()) {
				return `${this.monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			else {
				return `${this.monthNames[startDate.getMonth()]} ${startDate.getDate()} - ${this.monthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
		}
		else {
			if (end === '0001-01-01T00:00:00' || endDate.getFullYear() <= 1) {
				return `${this.monthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()}`;
			}
			return `${this.monthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.monthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
		}
	},
	formatDateRangeAbv(start, end) {
		let startDate = new Date(start);
		let endDate = new Date(end);
		let startMonth = startDate.getMonth() + 1;
		let endMonth = endDate.getMonth() + 1;
		if (startDate === '0001-01-01T00:00:00' || startDate.getFullYear() < 1990) {
			return '';
		}
		if (end === '0001-01-01T00:00:00' || endDate.getFullYear() <= 1 || startDate === endDate) {
			if (startMonth === 5) {
				return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()}`;
			} else if (startMonth === 9) {
				return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()}, ${startDate.getFullYear()}`;
			} else {
				return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()}, ${startDate.getFullYear()}`;
			}
		}
		else if (startDate.getFullYear() === endDate.getFullYear()) {
			if (startDate.getMonth() === endDate.getMonth()) {
				if (startMonth === 5) {
					return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()} - ${endDate.getDate()}, ${endDate.getFullYear()}`;
				} else if (startMonth === 9) {
					return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()} - ${endDate.getDate()}, ${endDate.getFullYear()}`;
				} else {
					return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()} - ${endDate.getDate()}, ${endDate.getFullYear()}`;
				}
			}
			else if (startMonth === 5) {
				return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			else if (endMonth === 5) {
				return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()} - ${this.abvMonthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			else if (startMonth === 9) {
				return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			else if (endMonth === 9) {
				return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()} - ${this.abvMonthNames[endDate.getMonth()]}t. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			else {
				return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
		}
		else {
			if (end === '0001-01-01T00:00:00' || endDate.getFullYear() <= 1) {
				return '';
			}
			if (startMonth === 5 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth === 5 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}t. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth === 9 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth === 9 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}t. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth !== 5 && endMonth === 5) {
					return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth === 5 && endMonth !== 5) {
					return `${this.abvMonthNames[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth !== 9 && endMonth === 9) {
					return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}t. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			} else if (startMonth === 9 && endMonth !== 9) {
					return `${this.abvMonthNames[startDate.getMonth()]}t. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
			}
			return `${this.abvMonthNames[startDate.getMonth()]}. ${startDate.getDate()}, ${startDate.getFullYear()} - ${this.abvMonthNames[endDate.getMonth()]}. ${endDate.getDate()}, ${endDate.getFullYear()}`;
		}
	},
};